import { motion } from "framer-motion";
import { ArrowDown, ArrowUpRight, Sparkles } from "lucide-react";

const lines = [{ text: "YOUR BUSINESS." }, { text: "ELEVATED.", accent: true }];

function MaskedLine({ children, index }) {
  return (
    <span className="block overflow-hidden pb-1">
      <motion.span
        className="block"
        initial={{ y: "112%", rotate: 2 }}
        animate={{ y: 0, rotate: 0 }}
        transition={{ duration: 1.05, delay: 0.25 + index * 0.13, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export default function Hero({ openBooking }) {
  return (
    <section id="top" data-testid="hero-section" className="relative flex min-h-screen items-center overflow-hidden pt-32 sm:pt-36">
      <div className="hero-grid absolute inset-0" aria-hidden="true" />
      <div className="absolute left-1/2 top-0 h-[34rem] w-[34rem] -translate-x-1/2 rounded-full bg-cyan-400/10 blur-[120px]" aria-hidden="true" />
      <div className="section-shell pb-24 pt-12 lg:pb-32">
        <div className="relative z-10 max-w-5xl">
          <motion.div data-testid="hero-availability-badge" initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} className="mb-8 inline-flex items-center gap-2 rounded-full border border-cyan-300/25 bg-cyan-300/10 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.24em] text-cyan-200">
            <Sparkles className="h-3.5 w-3.5" /> Available for new projects
          </motion.div>
          <h1 data-testid="hero-heading" className="font-display text-[2.25rem] font-extrabold uppercase leading-[0.92] tracking-[-0.07em] text-white sm:text-5xl lg:text-6xl xl:text-[5.2rem]">
            {lines.map((line, index) =>
              line.accent ? (
                <span key={line.text} className="block pb-1">
                  <span className="headline-underline relative block w-fit">{line.text}</span>
                </span>
              ) : (
                <MaskedLine key={line.text} index={index}>{line.text}</MaskedLine>
              )
            )}
          </h1>
          <motion.p data-testid="hero-subtitle" initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.75, duration: 0.8 }} className="mt-8 max-w-2xl text-base font-light leading-relaxed text-slate-300 sm:text-lg">
            Tybra designs and engineers custom business websites with the polish of a flagship product: bold, fast, mobile-first, and impossible to mistake for a template.
          </motion.p>
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.9, duration: 0.8 }} className="mt-10 flex flex-col gap-4 sm:flex-row">
            <button data-testid="hero-book-call-button" onClick={() => openBooking("New website")} className="cyan-button magnetic-button rounded-full px-8 py-4 font-mono text-xs font-bold uppercase tracking-[0.22em]">
              Book discovery call <ArrowUpRight className="h-4 w-4" />
            </button>
            <button data-testid="hero-view-pricing-button" onClick={() => document.querySelector("#pricing")?.scrollIntoView({ behavior: "smooth" })} className="outline-button rounded-full px-8 py-4 font-mono text-xs uppercase tracking-[0.22em]">
              View pricing <ArrowDown className="h-4 w-4" />
            </button>
          </motion.div>
        </div>
        <motion.div data-testid="hero-metrics-ticker" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.1 }} className="mx-auto mt-12 grid max-w-2xl grid-cols-1 divide-y divide-white/10 border-y border-white/10 text-center font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500 sm:grid-cols-3 sm:divide-x sm:divide-y-0 sm:text-xs">
          <span className="metric-glow px-3 py-4 text-cyan-200">100% custom code</span><span className="metric-glow px-3 py-4 text-cyan-200">2026 standard</span><span className="px-3 py-4 line-through decoration-white/40 decoration-2">0 templates</span>
        </motion.div>
      </div>
    </section>
  );
}
